var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2643(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 201,
    viewBox: "0 0 201 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.1194 0.76123H48.5597C21.7409 0.76123 4.57764e-05 22.5021 4.57764e-05 49.3209V49.3209C4.57764e-05 76.1397 21.741 97.8806 48.5597 97.8806H63.1194C81.8971 97.8806 97.1194 82.6582 97.1194 63.8806V0.76123Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 156.555C0 127.464 23.5833 103.881 52.6749 103.881H97.1193V201H0V156.555Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M200.239 152.44C200.239 125.622 178.498 103.881 151.679 103.881H103.119V201H151.679C178.498 201 200.239 179.259 200.239 152.44V152.44Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M103.119 0.76123H200.239V45.2057C200.239 74.2972 176.655 97.8806 147.564 97.8806H103.119V0.76123Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2643);
export default __webpack_public_path__ + "static/media/264-3.a149e6432bcd5c0b6d68907bd4b19153.svg";
export { ForwardRef as ReactComponent };